import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem("ms_admin_token") || null);
  const [checking, setChecking] = useState(!!token);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    let cancel = false;
    (async () => {
      try {
        await axios.get(`${API}/admin/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancel) setChecking(false);
      } catch {
        if (!cancel) {
          localStorage.removeItem("ms_admin_token");
          setToken(null);
          setChecking(false);
        }
      }
    })();
    return () => {
      cancel = true;
    };
  }, [token]);

  const logout = () => {
    localStorage.removeItem("ms_admin_token");
    setToken(null);
  };

  if (checking) {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen bg-black text-white flex items-center justify-center"
      >
        <span className="eyebrow">Checking session…</span>
      </div>
    );
  }

  if (!token) return <AdminLogin onAuthed={(t) => setToken(t)} />;
  return <AdminDashboard token={token} onLogout={logout} />;
}
